// 性别
export let sexArr = [
  {
    label: '男',
    value: 'MALE'
  },
  {
    label: '女',
    value: 'FEMALE'
  }
]
// 年龄段数据
export let ageGroup = [
  {
    label: '0-17',
    value: '0-17'
  },
  {
    label: '18-40',
    value: '18-40'
  },
  {
    label: '41-65',
    value: '41-65'
  },
  {
    label: '>66',
    value: '>66'
  }
]
// 健康档案type枚举
export let recordTypes = [
  {
    label: '病例',
    value: 'CASE'
  },
  {
    label: '医嘱',
    value: 'MEDICAL_ADVICE'
  },
  {
    label: '体检报告',
    value: 'MEDICAL_EXAMINATION_REPORT'
  }
]
// 证件类型枚举
export let identityCardType = [
  {
    label: '中国大陆居民身份证',
    value: 'CHINESE_IDENTITY_CARD'
  },
  {
    label: '护照',
    value: 'PASSPORT'
  },
  {
    label: '军官证',
    value: 'MILITARY_ID'
  }
]
// 里程碑类型
export let milestoneTypes = [
  {
    label: '注册会员',
    value: 'MEMBER'
  },
  {
    label: '基因检测',
    value: 'GENE'
  },
  {
    label: '保险投保',
    value: 'INSURANCE'
  },
  {
    label: '子女存储脐血存储',
    value: 'CPS'
  }
]
// 组织角色类型
export let organizationRoleType = [
  // {
  //   value: 'ANALYSIS',
  //   label: '计算商'
  // },
  {
    value: 'LAB',
    label: '实验室'
  }, {
    value: 'AGENT',
    label: '客户'
  }
  // {
  //   value: 'DISTRIBUTION',
  //   label: '直销商'
  // }
]
